"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const SvgCheckFilledIcon = (0, react_1.forwardRef)((props, ref) => {
    return ((0, jsx_runtime_1.jsx)("svg", Object.assign({ xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 25 25', ref: ref }, props, { children: (0, jsx_runtime_1.jsx)("path", { fill: 'currentColor', fillRule: 'nonzero', d: 'M12.5 25C19.404 25 25 19.404 25 12.5S19.404 0 12.5 0 0 5.596 0 12.5 5.596 25 12.5 25m5.518-14.795-6.25 6.25a1.167 1.167 0 0 1-1.656 0L6.987 13.33a1.171 1.171 0 0 1 1.655-1.655l2.296 2.295 5.42-5.425a1.171 1.171 0 0 1 1.655 1.655z' }) })));
});
exports.default = (0, react_1.memo)(SvgCheckFilledIcon);
